var path = 'app/scripts/modules/core/src/account/collapsibleAccountTag.directive.html';
var html = "<div class=\"heading-tag\">\n  <span class=\"account-tag account-tag-{{vm.accountType}}\">\n    <span class=\"small glyphicon glyphicon-chevron-{{vm.getIcon()}}\"></span>\n    {{vm.account}}\n  </span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/account/collapsibleAccountTag.directive.html
// module id = 978
// module chunks = 0